export default {
  title: 'Artigos esgotados',
  sections: {
    settings: 'Definições',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset: 'Os artigos esgotados são automaticamente marcados como disponíveis no final do dia.',
        manual_reset: 'A equipa tem de marcar os artigos como disponíveis novamente após os marcar como esgotados.',
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Erro ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
